<template>
    <v-stepper-content :step="step">
        <v-row justify="center">
            <v-col cols="12" sm="10" md="8" lg="6">
                <v-alert v-if="paymentError" type="error" border="left" colored-border>Terjadi kesalahan, coba lagi</v-alert>
                <v-file-input
                    @change="imageChange"
                    label="Upload bukti di sini"
                    accept="image/*"
                    prepend-icon="mdi-file-image"
                    :loading="imageCompressing"
                ></v-file-input>
            </v-col>
        </v-row>

        <div class="text-center">
            <v-btn @click="$emit('prevStep')" text class="mr-4">Kembali</v-btn>
            <v-btn
                @click="uploadProof"
                color="primary"
                :disabled="! proof"
                :loading="$store.get('loader/loading', 'payment')"
            >
                Selanjutnya
            </v-btn>
        </div>
    </v-stepper-content>
</template>

<script>
import createFormData from '@/tools/createFormData'
import imageCompression from 'browser-image-compression'

export default {
    props: {
        step: {
            type: String,
        }
    },

    data() {
        return {
            proof: null,
            imageCompressing: false,
            paymentError: false,
        }
    },

    methods: {
        imageChange(file) {
            if (!!file && file.size > 1024 * 1024) {
                this.imageCompressing = true

                imageCompression(file, {
                    maxSizeMB: 1,
                    maxWidthOrHeight: 2000,
                    useWebWorker: false,
                }).then(compressed => {
                    this.proof = compressed
                }).finally(() => {
                    this.imageCompressing = false
                })
            } else {
                this.proof = file
            }
        },

        uploadProof() {
            const data = createFormData({
                payment_proof: this.proof
            })

            this.$api.post('payment', data, { loader: 'payment' })
                .then(response => {
                    this.$tracking.event.program.confirmed(this.$store.get('enrollment/selected@title'))
                    if (response.data.paid) {
                        this.$emit('nextStep')
                    } else {
                        this.paymentError = true
                    }
                })
        },
    }
}
</script>
